<template>
	<div class="group-classes">
		<div class="d-flex justify-content-between align-items-center">
			<div class="px-0 mb-3" v-if="checkUser">
				<v-select
					auto-select-first
					v-bind:items="institutes"
					v-model="currentIns"
					v-on:change="changeInstitute"
					item-text="name"
					item-value="id"
					:label="$t('instituteName')"
					color="green"
					item-color="green"
				>
				</v-select>
			</div>
			<v-spacer></v-spacer>
			<v-btn color="primary" v-on:click="addGroupClass">
				<v-icon color="#fff" class="m-0 me-2">mdi-plus</v-icon> {{ $t("addNew") }}
			</v-btn>
		</div>
		<v-tabs
			v-model="tab"
			fixed-tabs
			dark
			background-color="#72a0e3"
			icons-and-text
			centered
		>
			<v-tab href="#upcoming" active-class="active-tab">
				{{ $t("upcoming") }}
				<v-icon>mdi-calendar-today</v-icon>
			</v-tab>
			<v-tab href="#past" active-class="active-tab">
				{{ $t("past") }}
				<v-icon>mdi-calendar-check</v-icon>
			</v-tab>
			<v-tabs-items v-model="tab">
				<v-tab-item
					v-for="singleTab in tabs"
					:key="singleTab.id"
					:value="singleTab.name"
					eager
				>
					<v-data-table
						class="mt-5"
						:headers="tableHeaders"
						:items="groupClasses[singleTab.name]"
						item-key="id"
						:footer-props="tableFooterOptions"
						:items-per-page="tableOptions.itemsPerPage"
						:server-items-length="totalGroupClasses"
						:no-data-text="noDataText"
						:options="tableOptions"
						@click:row="viewGroupClass"
						@update:options="updateGroupClasses"
					>
						<template v-slot:top>
							<v-toolbar flat>
								<v-toolbar-title>
									{{ $t(singleTab.preview + "Groups") }}</v-toolbar-title
								>
								<v-divider class="mx-4" inset vertical></v-divider>
								<v-spacer></v-spacer>
								<v-btn color="purple" dark v-on:click="printGroupClasses">
									<v-icon left>
										mdi-printer
									</v-icon>
									{{ $t("print") }}
								</v-btn>
								<v-divider class="mx-4" insent vertical></v-divider>
								<v-btn color="primary" @click.prevent="exportMode = true">
									<v-icon color="#fff" left>
										mdi-download
									</v-icon>
									{{ $t("exportData") }}
								</v-btn>
							</v-toolbar>
						</template>
						<template v-slot:item.actions="{ item }">
							<template v-if="tab === 'upcoming'">
								<v-tooltip top>
									<template v-slot:activator="{ on, attrs }">
										<v-icon
											class="mx-1"
											dense
											@click.stop="showTutorDialog(item)"
											v-bind="attrs"
											v-on="on"
										>
											mdi-clipboard-account
										</v-icon>
									</template>
									<span>{{
										$t("classGroups.groupClassDialog.assignTutor")
									}}</span>
								</v-tooltip>
								<v-tooltip top>
									<template v-slot:activator="{ on, attrs }">
										<v-icon
											class="mx-1"
											dense
											@click.stop="assignStudentGroup(item)"
											v-bind="attrs"
											v-on="on"
										>
											mdi-account-group
										</v-icon>
									</template>
									<span>{{
										$t("classGroups.groupClassDialog.assignStudentGroups")
									}}</span>
								</v-tooltip>
								<v-tooltip top>
									<template v-slot:activator="{ on, attrs }">
										<v-icon
											class="mx-1"
											v-bind="attrs"
											v-on="on"
											dense
											@click.stop="editGroupClass(item)"
										>
											mdi-pencil
										</v-icon>
									</template>
									<span>{{ $t("classGroups.groupClassDialog.edit") }}</span>
								</v-tooltip>
							</template>
							<v-tooltip top>
								<template v-slot:activator="{ on, attrs }">
									<v-icon
										class="mx-1"
										v-bind="attrs"
										v-on="on"
										dense
										@click.stop="showConfirmationDialog(item)"
									>
										mdi-delete
									</v-icon>
								</template>
								<span>{{ $t("classGroups.groupClassDialog.delete") }}</span>
							</v-tooltip>
						</template>
					</v-data-table>
				</v-tab-item>
			</v-tabs-items>
		</v-tabs>
		<v-dialog
			transition="dialog-bottom-transition"
			max-width="1100"
			v-model="groupClassDialog"
		>
			<v-card>
				<v-card-title>
					<span class="text-h5 p-3">
						{{ dialogTitle }}
					</span>
					<v-spacer></v-spacer>
					<v-btn
						class="mx-2"
						small
						color="primary"
						@click="groupClassDialog = false"
					>
						<v-icon dark>
							mdi-window-close
						</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<form class="row">
						<div class="col-md-6 px-4">
							<v-select
								filled
								:items="coursesTypes"
								v-model="groupClassDetails.course.course_type_name"
								@change="filterCourses"
								item-text="name"
								:label="$t('classGroups.groupClassDialog.coursesTypes')"
								color="green"
								class="mb-4"
								item-color="green"
								clearable
								clear-icon="mdi-close-circle"
								v-if="!viewMode"
							></v-select>
						</div>
						<div class="col-md-6 px-4">
							<v-autocomplete
								:items="courses"
								v-model="groupClassDetails.course.id"
								filled
								item-text="title"
								item-value="id"
								:label="$t('classGroups.groupClassDialog.selectCourse')"
								color="green"
								clear-icon="mdi-close-circle"
								:clearable="!viewMode"
								class="mb-4"
								:disabled="!groupClassDetails.course.course_type_name"
								v-if="!viewMode"
								item-color="green"
							></v-autocomplete>
						</div>
						<v-textarea
							filled
							v-model="groupClassDetails.description"
							class="mb-4 px-4"
							rows="3"
							color="green"
							auto-grow
							:label="$t('classGroups.groupClassDialog.description')"
							clearable
							clear-icon="mdi-close-circle"
							v-if="!viewMode"
						></v-textarea>
						<div class="col-md-6 px-4">
							<v-text-field
								v-model="groupClassDetails.name"
								:label="$t('classGroups.groupClassDialog.name')"
								type="text"
								filled
								:readonly="viewMode"
								color="green"
								class="mb-4"
								:clearable="!viewMode"
								clear-icon="mdi-close-circle"
							></v-text-field>
							<v-text-field
								v-model="groupClassDetails.session_duration"
								:label="$t('classGroups.groupClassDialog.noOfMinutes')"
								type="text"
								filled
								class="mb-4"
								:readonly="viewMode"
								color="green"
								:clearable="!viewMode"
								@input="changeSessionTime"
								clear-icon="mdi-close-circle"
							></v-text-field>
							<v-text-field
								v-model="groupClassDetails.min_required_students"
								:label="$t('classGroups.groupClassDialog.minNoOfStudents')"
								v-bind:type="viewMode ? 'text' : 'number'"
								filled
								class="mb-4"
								:readonly="viewMode"
								color="green"
								:clearable="!viewMode"
								clear-icon="mdi-close-circle"
							></v-text-field>
							<v-dialog
								v-if="!viewMode"
								ref="startDateDialog"
								v-model="startDateModal"
								:return-value.sync="groupClassDetails.start_date"
								presistent
								width="290px"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										v-model="groupClassDetails.start_date"
										:label="$t('classGroups.groupClassDialog.startDate')"
										prepend-icon="mdi-calendar"
										filled
										class="mb-4"
										v-bind="attrs"
										v-on="on"
										color="green"
										clearable
										clear-icon="mdi-close-circle"
										readonly
									>
									</v-text-field>
								</template>
								<v-date-picker
									v-model="groupClassDetails.start_date"
									v-bind:min="new Date().toISOString()"
								>
									<v-spacer></v-spacer>
									<v-btn text color="red" @click="startDateModal = false">
										{{ this.$t("Cancel") }}
									</v-btn>
									<v-btn
										text
										color="green"
										@click="
											$refs.startDateDialog.save(groupClassDetails.start_date)
										"
									>
										{{ this.$t("ok") }}
									</v-btn>
								</v-date-picker>
							</v-dialog>
							<v-text-field
								v-else
								v-model="groupClassDetails.start_date_string"
								:label="$t('classGroups.groupClassDialog.startDate')"
								type="text"
								filled
								class="mb-4"
								color="green"
								readonly
							></v-text-field>
							<v-dialog
								v-if="!viewMode"
								ref="startTimeDialog"
								v-model="startTimeModal"
								:return-value="groupClassDetails.start_time"
								presistent
								width="290px"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										v-model="groupClassDetails.start_time_string"
										:label="$t('classGroups.groupClassDialog.startTime')"
										filled
										color="green"
										type="text"
										clearable
										clear-icon="mdi-close-circle"
										class="mb-4"
										prepend-icon="mdi-clock-time-four-outline"
										v-bind="attrs"
										v-on="on"
										readonly
										@click:clear="
											groupClassDetails = {
												...groupClassDetails,
												end_time: '',
												end_time_string: '',
											}
										"
									>
									</v-text-field>
								</template>
								<v-time-picker
									v-model="groupClassDetails.start_time"
									full-width
									color="green"
									format="ampm"
									@change="changeSessionTime"
								>
									<v-spacer></v-spacer>
									<v-btn text color="red" v-on:click="startTimeModal = false">
										{{ this.$t("Cancel") }}
									</v-btn>
									<v-btn
										text
										color="green"
										v-on:click="
											$refs.startTimeDialog.save(groupClassDetails.start_time);
											changeSessionTime();
										"
									>
										{{ this.$t("ok") }}
									</v-btn>
								</v-time-picker>
							</v-dialog>
							<v-text-field
								v-else
								v-model="groupClassDetails.start_time_string"
								:label="$t('classGroups.groupClassDialog.startTime')"
								type="text"
								filled
								class="mb-4"
								:readonly="viewMode"
								color="green"
								:clearable="!viewMode"
								clear-icon="mdi-close-circle"
							></v-text-field>
							<v-text-field
								v-model="groupClassDetails.institute_group.name"
								label="Assigned Group"
								type="text"
								filled
								class="mb-4"
								:readonly="viewMode"
								color="green"
								:clearable="!viewMode"
								v-if="viewMode"
								clear-icon="mdi-close-circle"
							></v-text-field>
							<v-checkbox
								v-model="groupClassDetails.auto_renew"
								:label="$t('classGroups.groupClassDialog.autoRenew')"
								:disabled="viewMode"
								hide-details
							></v-checkbox>
						</div>
						<div class="col-md-6 px-4">
							<v-autocomplete
								v-if="!viewMode"
								v-model="groupClassDetails.days_selected"
								small-chips
								:items="weekDays"
								item-text="name"
								filled
								class="mb-4"
								multiple
								chips
								deletable-chips
								:label="$t('classGroups.groupClassDialog.days')"
								color="green"
								clearable
								clear-icon="mdi-close-circle"
								item-color="green"
								@change="
									groupClassDetails.days_per_week = groupClassDetails
										.days_selected.length
										? groupClassDetails.days_selected.length
										: null
								"
							>
							</v-autocomplete>
							<v-text-field
								v-else
								:value="getDays"
								:label="$t('classGroups.groupClassDialog.days')"
								type="text"
								filled
								readonly
								color="green"
								class="mb-4"
							></v-text-field>
							<v-text-field
								v-model="groupClassDetails.days_per_week"
								:label="$t('classGroups.groupClassDialog.noOfDaysPerWeek')"
								type="text"
								filled
								class="mb-4"
								:readonly="viewMode"
								color="green"
								:clearable="!viewMode"
								:disabled="
									!viewMode && !!groupClassDetails.days_selected.length
								"
								clear-icon="mdi-close-circle"
							></v-text-field>
							<v-text-field
								v-model="groupClassDetails.max_allowed_students"
								:label="$t('classGroups.groupClassDialog.maxNoOfStudents')"
								v-bind:type="viewMode ? 'text' : 'number'"
								filled
								class="mb-4"
								:readonly="viewMode"
								color="green"
								:clearable="!viewMode"
								clear-icon="mdi-close-circle"
							></v-text-field>
							<v-dialog
								v-if="!viewMode"
								ref="endDateDialog"
								v-model="endDateModal"
								:return-value.sync="groupClassDetails.end_date"
								presistent
								width="290px"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										v-model="groupClassDetails.end_date"
										:label="$t('classGroups.groupClassDialog.endDate')"
										prepend-icon="mdi-calendar"
										filled
										class="mb-4"
										v-bind="attrs"
										v-on="on"
										color="green"
										clearable
										clear-icon="mdi-close-circle"
										readonly
									>
									</v-text-field>
								</template>
								<v-date-picker
									v-model="groupClassDetails.end_date"
									v-bind:min="
										groupClassDetails.start_date || new Date().toISOString()
									"
								>
									<v-spacer></v-spacer>
									<v-btn text color="red" v-on:click="endDateModal = false">
										{{ this.$t("Cancel") }}
									</v-btn>
									<v-btn
										text
										color="green"
										v-on:click="
											$refs.endDateDialog.save(groupClassDetails.end_date)
										"
									>
										{{ this.$t("ok") }}
									</v-btn>
								</v-date-picker>
							</v-dialog>
							<v-text-field
								v-else
								v-model="groupClassDetails.end_date_string"
								:label="$t('classGroups.groupClassDialog.endDate')"
								type="text"
								filled
								class="mb-4"
								color="green"
								readonly
							></v-text-field>
							<v-text-field
								v-model="groupClassDetails.end_time_string"
								:label="$t('classGroups.groupClassDialog.endTime')"
								type="text"
								filled
								class="mb-4"
								:readonly="viewMode"
								:disabled="!viewMode"
								color="green"
								:clearable="!viewMode"
								clear-icon="mdi-close-circle"
							></v-text-field>
							<v-text-field
								v-model="groupClassDetails.total_students"
								:label="$t('classGroups.groupClassDialog.totalStudents')"
								type="text"
								filled
								class="mb-4"
								:readonly="viewMode"
								color="green"
								:clearable="!viewMode"
								v-if="viewMode"
								clear-icon="mdi-close-circle"
							></v-text-field>
							<v-text-field
								v-model="groupClassDetails.tutor.full_name"
								:label="$t('classGroups.groupClassDialog.assignedTutor')"
								type="text"
								filled
								class="mb-4"
								:readonly="viewMode"
								color="green"
								:clearable="!viewMode"
								v-if="viewMode"
								clear-icon="mdi-close-circle"
							></v-text-field>
						</div>
						<v-textarea
							filled
							v-model="groupClassDetails.description"
							class="mb-5 px-4"
							viewMode
							rows="3"
							color="green"
							auto-grow
							:label="$t('classGroups.groupClassDialog.description')"
							:clearable="!viewMode"
							clear-icon="mdi-close-circle"
							v-if="viewMode"
						></v-textarea>
						<div class="d-flex justify-content-end mb-4" v-if="viewMode">
							<v-btn
								color="red"
								class="text-white"
								type="button"
								@click.prevent="unassignStudentGroup(groupClassDetails.id)"
							>
								{{ this.$t("classGroups.groupClassDialog.unassign") }}
							</v-btn>
						</div>
						<div v-else class="d-flex justify-content-end mb-4">
							<v-btn
								color="red"
								class="text-white me-5"
								type="button"
								@click.prevent="groupClassDialog = false"
							>
								{{ this.$t("Cancel") }}
							</v-btn>
							<v-btn
								color="primary"
								class="text-white"
								type="button"
								@click.prevent="saveGroupClass"
								:disabled="isCreatingGroupClass"
							>
								{{
									editMode
										? `${this.$t("classGroups.groupClassDialog.save")}`
										: `${this.$t("classGroups.groupClassDialog.add")}`
								}}
							</v-btn>
						</div>
					</form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog
			transition="dialog-bottom-transition"
			max-width="700"
			v-model="tutorDialog"
		>
			<v-card>
				<v-card-title>
					<span class="text-h5 p-3">
						{{ this.$t("classGroups.tutorDialog.assignTutorFor") }}
						{{ groupClassDetails.name }}
					</span>
					<v-spacer></v-spacer>
					<v-btn
						class="mx-2"
						small
						color="primary"
						@click="tutorDialog = false"
					>
						<v-icon dark>
							mdi-window-close
						</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<form>
						<v-text-field
							v-model="groupClassDetails.course.course_type_name"
							:label="$t('classGroups.tutorDialog.courseType')"
							type="text"
							filled
							class="mb-4"
							readonly
							color="green"
							clear-icon="mdi-close-circle"
						></v-text-field>
						<v-text-field
							v-model="groupClassDetails.course.title"
							:label="$t('classGroups.tutorDialog.courseName')"
							type="text"
							filled
							class="mb-4"
							readonly
							color="green"
							clear-icon="mdi-close-circle"
						></v-text-field>
						<v-autocomplete
							:items="tutors"
							v-model="groupClassDetails.tutor.id"
							filled
							item-text="full_name"
							item-value="id"
							:label="$t('classGroups.tutorDialog.tutor')"
							color="green"
							clear-icon="mdi-close-circle"
							clearable
							class="mb-4"
							item-color="green"
						></v-autocomplete>
						<div class="d-flex justify-content-end mb-4">
							<v-btn
								color="red"
								class="text-white me-5"
								type="button"
								@click.prevent="tutorDialog = false"
							>
								{{ this.$t("Cancel") }}
							</v-btn>
							<v-btn
								color="primary"
								class="text-white"
								type="button"
								@click.prevent="assignTutor"
							>
								{{ this.$t("classGroups.tutorDialog.assign") }}
							</v-btn>
						</div>
					</form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<exportModal
			:exportMode="exportMode"
			@closeExport="exportMode = false"
			:columns="exportHeaders"
			:parameters="api_parameters"
			:totalListing="totalGroupClasses"
			apiPath="/b2b/class_group/list/"
			method="post"
			api_listing_attribute_name="groups"
			file_response_mode="inline"
		/>

		<ConfirmationModal
			:dialog="confirmationDialog"
			@closeDialog="handleConfirmationDialog"
			:data="confirmationData"
			:text="$t('ConfirmationModal.areYouSureYouWantToDeleteTheGroupClass')"
		/>
	</div>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";
import moment from "moment";
import ConfirmationModal from "./Modals/ConfirmationModal.vue";
import ExportModal from "./ExportData/ExportModal.vue";

export default {
	name: "GroupClassesView",
	mixins: [GlobalMixin],
	components: {
		ConfirmationModal,
		ExportModal,
	},
	data() {
		return {
			institutes: [],
			courses: [],
			coursesTypes: [],
			filteredCourses: [],
			tutors: [],
			currentIns: null,
			userObj: JSON.parse(localStorage.getItem("vuex")),

			tableFooterOptions: {
				"items-per-page-options": [10, 20, 30, 40, 50, 100],
				"show-current-page": true,
				showFirstLastPage: true,
				firstIcon: "mdi-arrow-collapse-left",
				lastIcon: "mdi-arrow-collapse-right",
			},
			tableOptions: {
				page: 1,
				offset: +this.$route.query.offset ? +this.$route.query.offset : 0,
				itemsPerPage: +this.$route.query.limit ? +this.$route.query.limit : 10,
				sortBy: [],
				sortDesc: [],
			},
			noDataText: "There is No Result.",

			// Table Data
			groupClasses: {
				upcoming: [],
				past: [],
			},
			totalGroupClasses: null,

			// Flags
			viewMode: false,
			editMode: false,

			// Exporting
			exportMode: false,
			api_parameters: {},
			exportHeaders: [
				{ text: this.$t("tables.name"), value: "name" },
				{ text: this.$t("tables.description"), value: "description" },
				{ text: this.$t("tables.startDate"), value: "start_date" },
				{ text: this.$t("tables.endDate"), value: "end_date" },
				{ text: this.$t("tables.startTime"), value: "start_time" },
				{ text: this.$t("tables.endTime"), value: "end_time" },
			],

			// Dialogs
			groupClassDialog: false,
			groupClassDetails: {
				id: "",
				name: "",
				description: "",
				auto_renew: false,
				session_duration: "",
				session_hours: "",
				days_per_week: "",
				days_selected: [],
				start_date: "",
				end_date: "",
				start_time: "",
				end_time: "",
				min_required_students: "",
				max_allowed_students: "",
				total_students: "",
				institute_group: {
					name: "",
				},
				tutor: {
					id: "",
					full_name: "",
				},
				course: {
					id: "",
					course_type_name: "",
					title: "",
				},
			},
			selectedCourseType: null,

			confirmationDialog: false,
			confirmationData: null,
			tutorDialog: false,
			startDateModal: false,
			endDateModal: false,
			startTimeModal: false,
			endTimeModal: false,

			tab: this.$route.hash.slice(1),
			tabs: [
				{ id: 1, name: "upcoming", preview: "Upcoming" },
				{ id: 2, name: "past", preview: "Past" },
			],

			isCreatingGroupClass: false,
		};
	},
	/**
	 * Initialize Component
	 */
	mounted() {
		// Get query params for the URL
		this.currentIns = +this.$route.query.ins
			? +this.$route.query.ins
			: this.getInstituteId;
		// Call institutes in case of super admin
		if (this.userObj.auth.user.user.user_type === "operator")
			this.getAllInstitutes();

		this.getCourses();
		this.getInstituteTutors();
	},
	methods: {
		/**
		 * Get all Institutes from the API
		 */
		getAllInstitutes() {
			this.axios(`${process.env.VUE_APP_APIEndPoint}institutes/`, this.headers)
				.then(
					res =>
						(this.institutes = res.data.data.sort((a, b) =>
							a?.name.toLowerCase() > b?.name.toLowerCase() ? 1 : -1
						))
				)
				.catch(err => console.error(err));
		},
		/**
		 * Get all Tutors for an institute
		 */
		getInstituteTutors() {
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}tutor/operator/listing/`,
					{
						status: "approved",
						institute: this.currentIns,
					},
					this.headers
				)
				.then(
					tutors =>
						(this.tutors = tutors.data.data.tutors.sort((a, b) =>
							a.full_name > b.full_name ? 1 : -1
						))
				)
				.catch(err => console.error(err));
		},
		/**
		 * Get Courses for a specific institute
		 */
		getCourses() {
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}tutor/courses/`,
					{
						institute: this.currentIns,
					},
					this.headers
				)
				.then(res => {
					this.allCourses = res.data.data.courses;
					this.coursesTypes = this.getCoursesTypes;
				})
				.catch(err => console.error(err));
		},
		/**
		 * Filter courses based on selected course type
		 */
		filterCourses() {
			this.courses = this.allCourses
				.filter(
					course =>
						course.course_type_name ===
						this.groupClassDetails.course.course_type_name
				)
				.sort((a, b) =>
					a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1
				);
		},
		/**
		 * Change Institute
		 */
		changeInstitute() {
			if (!this.currentIns) this.currentIns = 1;
			this.tableOptions.offset = 0;
			this.tableOptions.itemsPerPage = this.tableOptions.itemsPerPage;
			this.tableOptions.page = 1;
			this.tableOptions.sortBy = [];
			this.tableOptions.sortOrder = [];
			history.pushState(
				{},
				null,
				`${this.$route.path}?ins=${this.currentIns}&limit=${this.tableOptions.itemsPerPage}&offset=${this.tableOptions.offset}#${this.tab}`
			);
			this.getCourses();
			this.getInstituteTutors();
			this.getGroupClasses(
				this.tableOptions.offset,
				this.tableOptions.itemsPerPage,
				this.tab
			);
		},
		/**
		 * Get all upcoming or past Group Classes based on is_archived
		 * @param offset number
		 * @param limit number
		 * @param is_archived string
		 * @param sort_by string
		 * @param sort_order string
		 */
		getGroupClasses(
			offset = this.offset,
			limit = this.itemsPerPage,
			is_archived,
			sort_by = undefined,
			sort_order = undefined
		) {
			const body = {
				institute: this.currentIns,
				is_archived: is_archived === "upcoming" ? 0 : 1,
				limit,
				offset,
				sort_by: sort_by?.includes("_")
					? sort_by
							?.split("_")
							.slice(0, sort_by?.split("_").length - 1)
							.join("_")
					: sort_by,
				sort_order:
					typeof sort_order === "boolean"
						? sort_order
							? "desc"
							: "asc"
						: undefined,
			};
			this.api_parameters = body;

			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}b2b/class_group/list/`,
					body,
					this.headers
				)
				.then(res => {
					this.groupClasses[is_archived] = res.data.groups.map(group => {
						return {
							...group,
							start_date_string: moment(group.start_date).format("DD/MM/YYYY"),
							end_date_string: moment(group.end_date).format("DD/MM/YYYY"),
							start_time_string: moment(group.start_time, "HH:mm").format(
								"hh:mm A"
							),
							end_time_string: moment(group.end_time, "HH:mm").format(
								"hh:mm A"
							),
						};
					});
					this.totalGroupClasses = res.data.total_records;
				});
		},
		/**
		 * Opens groupClassDialog and resets groupClassDetails object to add new details
		 */
		addGroupClass() {
			this.groupClassDetails = {
				id: "",
				name: "",
				description: "",
				auto_renew: false,
				session_duration: "",
				session_hours: "",
				days_per_week: "",
				days_selected: [],
				start_date: "",
				end_date: "",
				start_time: "",
				end_time: "",
				min_required_students: "",
				max_allowed_students: "",
				total_students: "",
				institute_group: {
					name: "",
				},
				tutor: {
					id: "",
					full_name: "",
				},
				course: {
					id: "",
					course_type_name: "",
					title: "",
				},
			};
			this.groupClassDialog = true;
		},
		/**
		 * Edit Group class
		 * @param groupClass group class object
		 */
		editGroupClass(groupClass) {
			this.groupClassDetails = { ...groupClass };
			this.groupClassDetails.start_date_string = moment(
				groupClass.start_date
			).format("DD/MM/YYYY");
			this.groupClassDetails.end_date_string = moment(
				groupClass.end_date
			).format("DD/MM/YYYY");
			this.groupClassDetails.start_time_string = moment(
				groupClass.start_time,
				"HH:mm"
			).format("hh:mm A");
			this.groupClassDetails.end_time_string = moment(
				groupClass.end_time,
				"HH:mm"
			).format("hh:mm A");
			this.groupClassDetails.institute_group = groupClass.institute_group
				? groupClass.institute_group
				: { name: "" };
			this.groupClassDetails.tutor = groupClass.tutor || {
				id: "",
				full_name: "",
			};
			this.filterCourses();
			this.editMode = true;
			this.groupClassDialog = true;
		},
		/**
		 * Add or Update groupClass based on viewMode flag
		 */
		saveGroupClass() {
			this.isCreatingGroupClass = true

			const body = {
				...this.groupClassDetails,
				institute: this.currentIns,
				course: this.groupClassDetails.course.id,
				tutor: this.groupClassDetails.tutor.id,
				institute_group: this.groupClassDetails.institute_group.id,
				session_hours: Math.ceil(this.groupClassDetails.session_duration / 60),
			};

			if (this.editMode) {
				this.axios
					.put(
						`${process.env.VUE_APP_APIEndPoint}b2b/class_group/edit/${this.groupClassDetails.id}/`,
						body,
						this.headers
					)
					.then(res => {
						this.isCreatingGroupClass = false
						this.setAlert('success', " ", res.data.message, 2000)
						this.refreshTable(this.tab);
						this.groupClassDialog = false;
					})
					.catch(err => {
						this.isCreatingGroupClass = false
						this.formatErrors(err)
					});
				return;
			}

			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}b2b/class_group/create/`,
					body,
					this.headers
				)
				.then(res => {
					this.isCreatingGroupClass = false
					this.refreshTable(this.tab);
					this.groupClassDialog = false;
						this.setAlert('success', " ", res.data.message, 2000)
				})
				.catch(err => {
					this.isCreatingGroupClass = false
					this.formatErrors(err)
				});
		},
		/**
		 * View Group Class Details
		 * @param groupClass group class object
		 */
		viewGroupClass(groupClass) {
			this.viewMode = true;
			this.getGroupClassDetails(groupClass, "view");
		},
		/**
		 * Get more details for a specific group class
		 * @param groupClass group class object
		 * @param identifier string
		 */
		getGroupClassDetails(groupClass, identifier) {
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}b2b/class_group/detail/${groupClass.id}/`,
					this.headers
				)
				.then(res => {
					this.groupClassDetails = { ...res.data.group };
					this.groupClassDetails.start_date_string = moment(
						res.data.group.start_date
					).format("DD/MM/YYYY");
					this.groupClassDetails.end_date_string = moment(
						res.data.group.end_date
					).format("DD/MM/YYYY");
					this.groupClassDetails.start_time_string = moment(
						res.data.group.start_time,
						"HH:mm"
					).format("hh:mm A");
					this.groupClassDetails.end_time_string = moment(
						res.data.group.end_time,
						"HH:mm"
					).format("hh:mm A");
					this.groupClassDetails.institute_group = res.data.group
						.institute_group || { name: "" };
					this.groupClassDetails.tutor = res.data.group.tutor || {
						id: "",
						full_name: "",
					};
					this.groupClassDetails.session_duration += " Minutes";
					this.groupClassDetails.min_required_students =
						this.groupClassDetails.min_required_students +
						` Student${
							this.groupClassDetails.min_required_students > 1 ? "s" : ""
						}`;
					this.groupClassDetails.max_allowed_students += " Students";
					this.groupClassDetails.days_per_week =
						this.groupClassDetails.days_per_week +
						` Day${this.groupClassDetails.days_per_week > 1 ? "s" : ""}`;
					this.groupClassDetails.total_students =
						this.groupClassDetails.total_students +
						` Student${this.groupClassDetails.total_students > 1 ? "s" : ""}`;
					if (identifier === "view") this.groupClassDialog = true;
					else if (identifier === "tutor") this.tutorDialog = true;
				})
				.catch(err => this.formatErrors(err));
		},
		/**
		 * Unassign a class group from table
		 * @param group_id number
		 */
		unassignStudentGroup(group_id) {
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}b2b/class_group/remove/institute_group/`,
					{
						class_group: group_id,
					},
					{
						"USER-TIMEZONE": Intl.DateTimeFormat().resolvedOptions().timeZone,
					}
				)
				.then(res => {
					this.groupClassDialog = false;
					this.setAlert('success', " ", res.data.message, 2000)
				})
				.catch(err => this.formatErrors(err));
		},
		/**
		 * Delete Group Class from database and refresh table
		 * @param groupClass group class object
		 */
		deleteGroupClass(groupClass) {
			this.axios
				.delete(
					`${process.env.VUE_APP_APIEndPoint}b2b/class_group/delete/${groupClass.id}/?institute=${this.currentIns}`,
					{},
					this.headers
				)
				.then(res => {
					this.refreshTable(this.tab);
					this.confirmationData = null;
					this.confirmationDialog = false;
					this.setAlert('success', " ", res.data.message, 2000)
				})
				.catch(err => {
					this.confirmationDialog = false;
					this.formatErrors(err);
				});
		},
		/**
		 * Reset table sorting and refresh it
		 * @param tab number
		 */
		refreshTable(tab) {
			this.tableOptions.sortBy = [];
			this.tableOptions.sortOrder = [];
			this.getGroupClasses(
				this.tableOptions.offset,
				this.tableOptions.itemsPerPage,
				tab
			);
		},
		/**
		 * Show Tutor Dialog
		 * @param groupClass group class object
		 */
		showTutorDialog(groupClass) {
			this.groupClassDetails = groupClass;
			this.getGroupClassDetails(groupClass, "tutor");
		},
		/**
		 * Assign Tutor for a groupClass
		 */
		assignTutor() {
			const body = {
				institute: this.currentIns,
				tutor: this.groupClassDetails.tutor.id,
				class_group: this.groupClassDetails.id,
			};
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}b2b/class_group/assign_tutor/`,
					body,
					this.headers
				)
				.then(res => {
					this.tutorDialog = false;
					this.setAlert('success', " ", res.data.message, 2000)
				})
				.catch(err => this.formatErrors(err));
		},
		/**
		 * Show confirmation dialog
		 * @param groupClass group class object
		 */
		showConfirmationDialog(groupClass) {
			this.confirmationData = groupClass;
			this.confirmationDialog = true;
		},
		/**
		 * Handle response from confirmation dialog
		 * @param value boolean
		 */
		handleConfirmationDialog(value) {
			if (!value) return (this.confirmationDialog = false);
			this.deleteGroupClass(value);
		},
		/**
		 * Navigate to assign student group Page
		 * @param groupClass group class object
		 */
		assignStudentGroup(groupClass) {
			this.$router.push({
				name: "AssignStudentGroup",
				params: { id: groupClass.id, ins: this.currentIns },
			});
		},
		/**
		 * Update updateGroupClasses table
		 * @param options options object
		 */
		updateGroupClasses(options) {
			this.tableOptions.sortBy = options.sortBy || [];
			this.tableOptions.sortDesc = options.sortDesc || [];
			if (!this.currentIns) this.currentIns = this.getInstituteId;
			// Get neccessary values for table (itemsPerPage, page, offset)
			this.tableOptions.offset = options.itemsPerPage * (options.page - 1);
			this.tableOptions.itemsPerPage = options.itemsPerPage;
			this.tableOptions.page = this.tableOptions.offset
				? this.tableOptions.offset / this.tableOptions.itemsPerPage + 1
				: 1;
			// Change URL without reloading the page
			history.pushState(
				{},
				null,
				`${this.$route.path}?ins=${this.currentIns}&limit=${this.tableOptions.itemsPerPage}&offset=${this.tableOptions.offset}#${this.tab}`
			);
			// Get updated students with new params
			this.getGroupClasses(
				this.tableOptions.offset,
				this.tableOptions.itemsPerPage,
				this.tab,
				this.tableOptions.sortBy[0],
				this.tableOptions.sortDesc[0]
			);
		},
		/**
		 * Calculate end_time based on seleced start_time and no. of minutes
		 */
		changeSessionTime() {
			// Return if there is any missing reuired field
			if (
				(!this.groupClassDetails.session_duration &&
					!this.groupClassDetails.start_time) ||
				(this.groupClassDetails.session_duration &&
					!this.groupClassDetails.start_time)
			) {
				this.groupClassDetails = {
					...this.groupClassDetails,
					end_time: "",
					end_time_string: "",
					start_time: "",
					start_time_string: "",
				};
				return;
			}
			// Return if there's no session_duration
			if (
				this.groupClassDetails.start_time &&
				!this.groupClassDetails.session_duration
			) {
				this.groupClassDetails = {
					...this.groupClassDetails,
					end_time: "",
					end_time_string: "",
				};
				return (this.groupClassDetails.start_time_string = moment(
					this.groupClassDetails.start_time,
					"HH:mm"
				).format("hh:mm A"));
			}
			this.groupClassDetails.start_time_string = moment(
				this.groupClassDetails.start_time,
				"HH:mm"
			).format("hh:mm A");
			this.groupClassDetails.end_time = moment(
				this.groupClassDetails.start_time,
				"HH:mm"
			)
				.add(this.groupClassDetails.session_duration, "minutes")
				.format("HH:mm");
			this.groupClassDetails.end_time_string = moment(
				this.groupClassDetails.end_time,
				"HH:mm"
			).format("hh:mm A");
		},
		/**
		 * Print upcoming / past groupClasses List
		 */
		printGroupClasses() {
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}institutes/export_pdf/`,
					{
						api_path: "/b2b/class_group/list/",
						api_parameters: {
							...this.api_parameters,
							limit: this.totalGroupClasses,
							offset: 0,
						},
						api_listing_attribute_name: "groups",
						columns_details: [
							{ name: "Name", attribute_path: "name" },
							{ name: "Description", attribute_path: "description" },
							{ name: "Start date", attribute_path: "start_date" },
							{ name: "End date", attribute_path: "end_date" },
							{ name: "Start time	", attribute_path: "start_time" },
							{ name: "End time", attribute_path: "end_time" },
						],
						file_response_mode: "attachment",
					},
					{
						responseType: "blob",
					}
				)
				.then(res => {
					const url = window.URL.createObjectURL(
						new Blob([res.data], { type: "application/pdf" })
					);
					const iframe = document.createElement("iframe");
					iframe.style.display = "none";
					iframe.src = url;
					document.body.appendChild(iframe);
					iframe.onload = () => {
						this.loading = false;
						iframe.contentWindow.focus();
						iframe.contentWindow.print();
					};
				});
		},
	},
	computed: {
		/**
		 * Check if user is super admin or not
		 */
		checkUser() {
			return this.userObj.auth.user.user.user_type === "operator";
		},
		/**
		 * Class group dialog title
		 */
		dialogTitle() {
			return this.editMode
				? `${this.$t("classGroups.groupClassDialog.editGroupClass")}`
				: `${this.$t("classGroups.groupClassDialog.groupClass")}`;
		},
		/**
		 * Get days as a string to use it in viewMode
		 */
		getDays() {
			return this.groupClassDetails.days_selected
				.map(day => {
					return this.weekDaysStrings[day];
				})
				.join(", ");
		},
		weekDaysStrings() {
			return [
				"",
				`${this.$t("weekDaysStrings.monday")}`,
				`${this.$t("weekDaysStrings.tuesday")}`,
				`${this.$t("weekDaysStrings.wednesday")}`,
				`${this.$t("weekDaysStrings.thursday")}`,
				`${this.$t("weekDaysStrings.friday")}`,
				`${this.$t("weekDaysStrings.saturday")}`,
				`${this.$t("weekDaysStrings.sunday")}`,
			];
		},
		/**
		 * Gets currnent choosed institute ID
		 */
		getInstituteId() {
			return this.userObj.auth.user.user.user_type === "operator"
				? 1
				: +this.userObj.auth.user.user.username.slice("").at(-1);
		},
		/**
		 * Get Courses types based on all courses
		 */
		getCoursesTypes() {
			return [
				...new Set(
					this.allCourses
						.map(course => course.course_type_name)
						.sort((a, b) => (a > b ? 1 : -1))
				),
			];
		},
		/**
		 * Headers translations for table
		 * @returns []
		 */
		tableHeaders() {
			return [
				{ text: this.$t("tables.name"), value: "name" },
				{ text: this.$t("tables.description"), value: "description" },
				{ text: this.$t("tables.startDate"), value: "start_date_string" },
				{ text: this.$t("tables.endDate"), value: "end_date_string" },
				{ text: this.$t("tables.startTime"), value: "start_time_string" },
				{ text: this.$t("tables.endTime"), value: "end_time_string" },
				{ text: this.$t("tables.actions"), value: "actions", sortable: false },
			];
		},
	},
	watch: {
		/**
		 * Change viewMode and editMode to false when groupClassDialog is closed
		 * @param newVal boolean
		 */
		groupClassDialog(newVal) {
			if (!newVal) {
				this.viewMode = false;
				this.editMode = false;
				this.selectedCourseType = null;
				this.groupClassDetails = {
					id: "",
					name: "",
					description: "",
					auto_renew: false,
					session_duration: "",
					session_hours: "",
					days_per_week: "",
					days_selected: [],
					start_date: "",
					end_date: "",
					start_time: "",
					end_time: "",
					min_required_students: "",
					max_allowed_students: "",
					total_students: "",
					institute_group: {
						name: "",
					},
					tutor: {
						id: "",
						full_name: "",
					},
					course: {
						id: "",
						course_type_name: "",
						title: "",
					},
				};
			}
		},
		/**
		 * Change tab property to 0 or 1 based on active tab
		 * @param newVal number
		 */
		tab(newVal) {
			this.tableOptions = {
				page: 1,
				offset: 0,
				itemsPerPage: 10,
				sortBy: [],
				sortDesc: [],
			};
			// Change URL without reloading the page
			history.pushState(
				{},
				null,
				`${this.$route.path}?ins=${this.currentIns}&limit=${this.tableOptions.itemsPerPage}&offset=${this.tableOptions.offset}#${newVal}`
			);
			this.refreshTable(newVal);
		},
		newGroupClass: {
			handler(newVal, oldVal) {
				if (newVal.days_selected.length) {
					this.newGroupClass.days_per_week = newVal.days_selected.length;
				}
				if (newVal.start_time !== "" && newVal.session_duration) {
					this.newGroupClass.end_time = moment(newVal.start_time, "HH:mm")
						.add(newVal.session_duration, "minutes")
						.format("HH:mm");
				}
			},
			deep: true,
		},
		tempGroupClassEdit: {
			handler(newVal, oldVal) {
				if (newVal.days_selected.length) {
					this.tempGroupClassEdit.days_per_week = newVal.days_selected.length;
				}
				if (newVal.start_time !== "" && newVal.session_duration) {
					this.tempGroupClassEdit.end_time = moment(newVal.start_time, "HH:mm")
						.add(newVal.session_duration, "minutes")
						.format("HH:mm");
				}
			},
			deep: true,
		},
	},
};
</script>

<style scoped lang="scss">
.table-box {
	min-height: 730px;
}

.active-tab {
	background: #1976d2;
}

::v-deep .v-text-field__details {
	display: none;
}

::v-deep .v-input__slot {
	margin: 0;
}
</style>
